export interface LogbuchValue {
    field: string | null;
    value: string | null;
}

export interface LogbuchChange {
    field: string | null;
    old: string | null;
    new: string | null;
}

export interface LogbuchEintrag {
    text: string | null;
}

export interface LogbuchCreateMessage extends LogbuchEintrag {
    created: LogbuchValue[] | null;
}

export interface LogbuchUpdateMessage extends LogbuchEintrag {
    changes: LogbuchChange[] | null;
}

export interface LogbuchDeleteMessage extends LogbuchEintrag {
    deleted: LogbuchValue[] | null;
}

export type LogbuchTypeMessage = string | LogbuchCreateMessage | LogbuchUpdateMessage | LogbuchDeleteMessage;

export enum Priority {
    Emerg = 0,
    Alert = 1,
    Crit = 2,
    Err = 3,
    Warn = 4,
    Notice = 5,
    Info = 6,
    Debug = 7,
}

export enum Methods {
    Create = 1,
    Update = 2,
    Zugriff = 3,
    Delete = 4,
    Storno = 5,
    Cancel = 6,
    Email = 7,
    Sms = 8,
    Druck = 9,
    Export = 10,
    Elga = 11,
    ElgaCreate = 12,
    ElgaCancel = 13,
    Kassa = 14,
    Rechnung = 15,
    Lager = 16,
    Wavm = 17,
    ElgaUebertragung = 18,
    Transfer = 19,
}

export enum Eintragsart {
    Impfung = 'Impfung',
    Nachtrag = 'Nachtrag',
    Reiseplan = 'Reiseplan',
    Texteintrag = 'Texteintrag',
    Leistung = 'Leistung',
    Untersuchung = 'Untersuchung',
    Diagnose = 'Diagnose',
    Anamnese = 'Anamnese',
    Brief = 'Brief',
    Rezept = 'Rezept',
}

export default class Logbuch {
    public log_id: number | null = null;
    public timestamp: string | null = null;
    public priority: Priority | null = null;
    public priorityname: string | null = null;
    public message: LogbuchTypeMessage | null = null;
    public extra_impfstelle_id: number | null = null;
    public extra_patnr: number | null = null;
    public extra_aktion: Methods | null = null;
    public extra_ip: string | null = null;
    public extra_user_id: number | null = null;
    public extra_errno: number | null = null;
    public extra_file: string | null = null;
    public extra_line: number | null = null;
    public extra_trace: string | null = null;
    public extra_function: string | null = null;
    public extra_xdebug: string | null = null;
    public extra_class: string | null = null;
    public user_vorname: string | null = null;
    public user_nachname: string | null = null;
    public user_gv_ou_id: string | null = null;
    public impfstelle_abkuerzung: string | null = null;
    public impfstelle_bezeichnung: string | null = null;

    public get isCreate(): boolean {
        return !!(this.message as LogbuchCreateMessage)?.created;
    }

    public get isUpdate(): boolean {
        return !!(this.message as LogbuchUpdateMessage)?.changes;
    }

    public get isDelete(): boolean {
        return !!(this.message as LogbuchDeleteMessage)?.deleted;
    }

    constructor(data?: Partial<Logbuch>) {
        Object.assign(this, data);
    }
}
